import { Paper } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import PublicScaffold from "@/routes/-components/PublicScaffold.js";

const Root = (): ReactNode => {
    return (
        <PublicScaffold>
            <Paper>
                <Outlet />
            </Paper>
        </PublicScaffold>
    );
};

export const Route = createFileRoute("/registration")({
    component: Root,
});
